export enum FinancialReportPeriod {
  MONTHLY = 'MONTHLY',
  CUSTOM = 'CUSTOM',
}
